module.exports = __webpack_public_path__ + "img/Bernd Leno.5cfb5196.png";